import createIcon from '../../createIcon';

/**
 * @component @name Upgrade
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgMThWMjBIOFYxOEgxNlpNMTEgNy45OVYxNkgxM1Y3Ljk5SDE2TDEyIDRMOCA3Ljk5SDExWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Upgrade = createIcon('Upgrade', [
  ['path', { d: 'M16 18V20H8V18H16ZM11 7.99V16H13V7.99H16L12 4L8 7.99H11Z', key: 'e69of6' }],
]);

export default Upgrade;
